import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import LoginServices from '../../services/LoginServices';
import { LoaderButton } from '../genericComponents/Button/LoaderButton';
import * as ReqType from '../../types/ServerRequests';
import { Redirect } from 'react-router';
import { EventService } from '../../services/EventService';
import { InfoEvent } from './internalComponents/InfoEvent';
import { ListFraisEvent } from './internalComponents/ListFraisEvent';
import { ListParticipantsEvent } from './internalComponents/ListParticipantsEvent';
import { MediaEvent } from './internalComponents/MediaEvent';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    match: {
        path: string,
        url: string,
        isExact: boolean,
        params: {
            id: string
        }
    };
}

/**
 * interface State (l'état interne de la classe CreateEventPage)
 * redirect, event, participation,
 */
interface State {
    redirect: boolean;
    event?: ReqType.Event;
    participation: boolean;
    displayParticipationButtons: boolean;
    listParticipant: ReqType.Presence[];
}

/**
 * la classe EventPage permet d'affichage d'un évènement
 */
export class EventPage extends React.Component {
    props: Props;
    state: State;

    /**
     * le constructeur de la classe EventPage
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            redirect: false,
            participation: true,
            displayParticipationButtons: false,
            listParticipant: [],
        };
        this.getEvent();
        this.getListeParticipants();
    }

    /**
     * @returns {JSX.Element}
     */
    render() {
        var infoEvent = undefined;
        var header = undefined;
        if (this.state.event !== undefined) {
            infoEvent = (
                <div className="col-12 rounded">
                    <InfoEvent
                        information={this.state.event}
                        changeEvent={
                            (e: ReqType.Event) => {
                                this.setState({ event: e });
                            }
                        }
                    />
                </div>
            );
            if (this.state.event !== null) {
                header = (
                    <div className="margin-top">
                        <h1 style={{ color: '#ED008C' }} className="text-center HeaderElement">
                            {this.state.event.intitule}
                        </h1>
                    </div>
                );
            }
        }

        if (this.state.redirect) {
            return <Redirect to={'/schedule'} />;
        }
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.SEMI_PRO,
                ]}
            >
                <div style={{ paddingBottom: '20px' }}>
                    <div className="row d-flex justify-content-between">
                        <div>
                            {this.EventDeleteButton()}
                        </div>
                        {this.EventValideParticipation()}
                    </div>
                    <br />
                    {header}
                    {infoEvent}
                    {this.displayFrais()}
                    {this.displayParticipants()}
                    {this.displayMedias()}
                </div>
            </PageChorinitia>
        );
    }

    private displayMedias(): JSX.Element | undefined {
        if (this.state.event !== undefined) {
            return (
                <MediaEvent
                    media={this.state.event.media}
                    eventId={this.state.event.id}
                    changeMedias={
                        (list: ReqType.Media[]) => {
                            if (this.state.event !== undefined) {
                                var event = EventService.getInstance().duplicateEvent(this.state.event);
                                event.media = list;
                                this.setState({ event: event });
                            }
                        }
                    }
                />
            );
        } else {
            return undefined;
        }
    }

    private displayFrais(): JSX.Element | undefined {
        const userRole = LoginServices.getInstance().getType();
        if (this.state.event === undefined) {
            return undefined;
        }
        if (userRole === UserRole.ADMIN.toString() ||
            (userRole === UserRole.SEMI_PRO.toString() && this.state.displayParticipationButtons)
        ) {
            return (
                <ListFraisEvent
                    event={this.state.event}
                />
            );
        } else {
            return undefined;
        }
    }

    private displayParticipants(): JSX.Element | undefined {
        if (this.state.event !== undefined) {
            // event={this.state.event}
            return (
                <ListParticipantsEvent
                    event={this.state.event}
                    displayAddCallback={
                        (b: boolean) => {
                            this.setState({ displayParticipationButtons: b });
                        }
                    }
                    listParticipant={this.state.listParticipant}
                    addPresence={
                        (p: ReqType.Presence) => {
                            this.state.listParticipant.push(p);
                            this.setState({
                                listParticipant: this.state.listParticipant,
                                select: true
                            });
                        }
                    }
                    removePresence={
                        (n: number) => {
                            this.state.listParticipant.splice(n, 1);

                            this.setState({
                                listParticipant: this.state.listParticipant
                            });
                        }
                    }
                />
            );
        } else {
            return undefined;
        }
    }

    private getListeParticipants(): void {
        EventService.getInstance().getParticipants(Number.parseInt(this.props.match.params.id)).then(
            (listUser: ReqType.Presence[]) => {
                const userId = LoginServices.getInstance().getUserId();
                this.setState({
                    listParticipant: listUser
                });
                if (userId !== undefined) {
                    var userFound = listUser.find(
                        (u: ReqType.Presence) => {
                            return u.user_id === userId;
                        }
                    );
                    this.setState({
                        displayParticipationButtons: userFound !== undefined,
                        participation: userFound === undefined ? false : !userFound.presence,
                    });
                }
            }
        ).catch(
            (error) => {
                alert(error);
            }
        );
    }

    private deleteEventServer = () => {
        if (this.state.event !== undefined) {
            return EventService.getInstance().deleteEvent(this.state.event).then(
                () => {
                    this.setState({ redirect: true });
                }
            ).catch(
                () => {
                    alert('Il y a encore des frais associés à cet événement');
                }
            );
        } else {
            return Promise.resolve();
        }
    }

    private EventDeleteButton(): JSX.Element | undefined {
        const userRole = LoginServices.getInstance().getType();

        if (
            userRole === UserRole.MEMBER.toString() ||
            userRole === UserRole.USER.toString() ||
            userRole === UserRole.SEMI_PRO.toString()
        ) {
            return undefined;
        } else if (
            userRole === UserRole.ADMIN.toString()
        ) {
            return (
                <LoaderButton
                    className="btn btn-outline-secondary font-weight-bold"
                    onClick={this.deleteEventServer}
                    confirmation={true}
                    style={{ marginTop: '20px', marginBottom: '20px', marginLeft: '20px' }}
                    modalTitle="supprimer un evenement"
                    modalBody={'êtes-vous sûr de supprimer ' +
                        (this.state.event === undefined ? '' : this.state.event.intitule)}
                >
                    Supprimer l'Evènement
                </LoaderButton>
            );
        }
        return undefined;
    }

    private OnClickValideParticipation = () => {
        return EventService.getInstance().confirmParticipation(Number.parseInt(this.props.match.params.id), true).then(
            () => {
                const userId = LoginServices.getInstance().getUserId();
                const part = this.state.listParticipant.find(
                    (elem: ReqType.Presence) => {
                        return (elem.user_id === userId);
                    }
                );
                if (part !== undefined) {
                    part.presence = true;
                }
                this.setState({
                    participation: false,
                    listParticipant: this.state.listParticipant,
                });
            }
        );
    }

    private OnClickDeclineParticipation = () => {
        return EventService.getInstance().confirmParticipation(Number.parseInt(this.props.match.params.id), false).then(
            () => {
                const userId = LoginServices.getInstance().getUserId();
                const part = this.state.listParticipant.find(
                    (elem: ReqType.Presence) => {
                        return (elem.user_id === userId);
                    }
                );
                if (part !== undefined) {
                    part.presence = false;
                }
                this.setState({
                    participation: true,
                    listParticipant: this.state.listParticipant,
                });
            }
        );
    }

    private EventValideParticipation(): JSX.Element | undefined {
        const userRole = LoginServices.getInstance().getType();

        if (userRole === UserRole.USER.toString() ||
            !this.state.displayParticipationButtons
        ) {
            return undefined;
        } else if (
            userRole === UserRole.MEMBER.toString() ||
            userRole === UserRole.ADMIN.toString() ||
            userRole === UserRole.SEMI_PRO.toString()
        ) {
            return (
                <div className="btn-group" style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' }}>
                    <LoaderButton
                        className="btn "
                        style={{ marginRight: '5px', background: '#ED008C' }}
                        onClick={this.OnClickValideParticipation}
                        disabled={!this.state.participation}
                        confirmation={true}
                        modalTitle="Validé ma Participation"
                        modalBody="Etes vous certain de vouloir participer à cet évènement ?"
                    >
                        <strong>Je viens</strong>
                    </LoaderButton>
                    <LoaderButton
                        className="btn "
                        style={{ background: '#ED008C' }}
                        onClick={this.OnClickDeclineParticipation}
                        disabled={this.state.participation}
                        confirmation={true}
                        modalTitle="Decliné ma Participation"
                        modalBody="Etes vous certain de vouloir decliner participer à cet évènement ?"
                    >
                        <strong>Je viens pas</strong>
                    </LoaderButton>
                </div>
            );
        }
        return undefined;
    }

    private getEvent() {
        EventService.getInstance().getEvent(Number.parseInt(this.props.match.params.id)).then(
            (event: ReqType.Event) => {
                this.setState({ event: event });
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/EventPage.tsx